export interface EnvironmentConfig {
  production: boolean;
  [key: string]: any;
}

// Single runtime environment object populated from backend /environment before bootstrap
export const environment: EnvironmentConfig = {
  // Default used at build/test time; overwritten at runtime by /environment
  production: false,
};